<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div @click="down_import_template" style="text-align: center;cursor: pointer;">
				<img style="width: 80px;height: 80px;" src="../../assets/staff/muban.png" />
				<div style="text-align: center;font-size: 12px;color: #1E69FF;">
					下载批量导入模板
				</div>
			</div>
			<el-upload
			:action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
			:show-file-list="false" 
			name="file"
			:data="{'act':'batch_import_card','token':token,'user_id':user_id}"
			:on-success="fileSuccess"
			accept='.xlsx,.xls,.csv'>
				<div style="text-align: center;cursor: pointer;margin-left: 120px;">
					
					<img style="width: 80px;height: 80px;" src="../../assets/staff/tianjiawanjian.png" />
					<div style="text-align: center;font-size: 12px;color: #1E69FF;">
						上传批量生成文件
					</div>
				</div>
			</el-upload>
			
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
			}
		},
		created() {

		},
		methods:{
			//下载批量导入模板
			down_import_template(){
				let params = {
					act:'down_import_template',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				
				this.$api.down_import_template(params).then((res)=>{
					if(res.code == 0){
						window.open(res.data)
					}
				})
				
			},
			fileSuccess(res){
				if(res.code == 0){
					this.$message({
						showClose: false,
						message: '导入成功请在待录入模块进行员工录入',
						type: 'success',
						offset: 350
					})
				}else{
					this.$message({
						showClose: false,
						message: res.msg,
						type: 'error',
						offset: 350
					})
				}
			}
		}
		
	}
</script>

<style scoped="">
	.content-box{
		margin-top: 1.44rem;
		width: 100%;
		background: #FFFFFF;
		border-radius: 6px;
		min-height: 650px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
